document.documentElement.classList.remove('no-js');

const body = document.body;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const header = document.querySelector('[data-site-header]');
const menuButton = document.querySelector('.menu-button');
const mobileMenu = document.querySelector('.mobile-menu');
const scrollProgress = document.querySelector('.site-scroll-progress');
const transition = document.querySelector('.page-transition');
const guardToast = document.querySelector('.media-guard-toast');
const activeView = document.documentElement.dataset.gfxView || 'home';

const updateHeader = () => {
  const distance = document.documentElement.scrollHeight - window.innerHeight;
  header?.classList.toggle('site-header--scrolled', window.scrollY > 40);
  if (scrollProgress) scrollProgress.style.transform = `scaleX(${distance > 0 ? Math.min(1, window.scrollY / distance) : 0})`;
};
updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

menuButton?.addEventListener('click', () => {
  const open = mobileMenu?.classList.toggle('mobile-menu--open') || false;
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.querySelector('span').textContent = open ? 'Cerrar' : 'Menú';
  body.style.overflow = open ? 'hidden' : '';
});

const entryGate = document.querySelector('[data-entry-gate]');
if (entryGate && activeView !== 'home') entryGate.classList.add('is-hidden');
if (entryGate && activeView === 'home') {
  let seen = false;
  try { seen = sessionStorage.getItem('gfxperezz-entry') === '1'; } catch (error) { seen = false; }
  if (seen) entryGate.classList.add('is-hidden');
  else {
    body.style.overflow = 'hidden';
    const enter = () => {
      if (entryGate.classList.contains('is-leaving')) return;
      try { sessionStorage.setItem('gfxperezz-entry', '1'); } catch (error) { void error; }
      entryGate.classList.add('is-leaving');
      body.style.overflow = '';
      window.setTimeout(() => entryGate.classList.add('is-hidden'), reduceMotion ? 950 : 1450);
    };
    entryGate.addEventListener('click', enter);
    entryGate.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') enter(); });
  }
}

const routeDetails = destination => {
  if (destination === '/' || destination === '#inicio') return ['home', 'INICIO', 'VOLVER AL ORIGEN'];
  if (destination.includes('/diseno') || destination.includes('view=design') || destination === '#diseno') return ['design', 'DISEÑO', 'IDENTIDAD VISUAL'];
  if (destination.includes('/video') || destination.includes('view=video') || destination === '#video') return ['video', 'VÍDEO', 'MOVIMIENTO · RITMO · EMOCIÓN'];
  if (destination.includes('/album') || destination.includes('view=album') || destination === '#album') return ['album', 'ÁLBUM', 'FOTOGRAFÍA DEPORTIVA'];
  if (destination.includes('/opiniones') || destination.includes('view=reviews') || destination === '#opiniones') return ['reviews', 'OPINIONES', 'EXPERIENCIAS REALES'];
  if (destination === '#sobre-mi') return ['default', 'SOBRE MÍ', 'HISTORIA · MIRADA · IDENTIDAD'];
  if (destination === '#reservar') return ['default', 'RESERVAR', 'TU PARTIDO · MI CÁMARA'];
  return ['default', 'GFXPEREZZ', 'CARGANDO EXPERIENCIA'];
};

document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.protocol === 'mailto:' || url.protocol === 'tel:') return;
  const sameDocument = url.pathname === window.location.pathname && url.search === window.location.search;
  const sectionRoutes = ['#inicio', '#diseno', '#video', '#album', '#opiniones', '#sobre-mi', '#reservar'];
  if (sameDocument && (!url.hash || !sectionRoutes.includes(url.hash))) return;
  if (!transition || window.Shopify?.designMode) return;
  event.preventDefault();
  const view = url.searchParams.get('view');
  const [style, label, eyebrow] = routeDetails(view ? `view=${view}` : url.hash || url.pathname);
  transition.className = `page-transition page-transition--${style} is-active`;
  transition.hidden = false;
  transition.querySelector('[data-transition-label]').textContent = label;
  transition.querySelector('[data-transition-eyebrow]').textContent = eyebrow;
  body.style.overflow = 'hidden';
  if (sameDocument) {
    const delay = reduceMotion ? 260 : 850;
    window.setTimeout(() => {
      document.querySelector(url.hash)?.scrollIntoView({ behavior: 'auto', block: 'start' });
      window.history.pushState(null, '', url.hash);
      mobileMenu?.classList.remove('mobile-menu--open');
      menuButton?.setAttribute('aria-expanded', 'false');
      if (menuButton?.querySelector('span')) menuButton.querySelector('span').textContent = 'Menú';
      transition.classList.add('is-revealing');
      body.style.overflow = '';
      window.setTimeout(() => {
        transition.hidden = true;
        transition.className = 'page-transition';
      }, reduceMotion ? 220 : 480);
    }, delay);
    return;
  }
  window.setTimeout(() => { window.location.href = url.href; }, reduceMotion ? 700 : 1250);
});
window.addEventListener('pageshow', () => { if (transition) { transition.hidden = true; transition.classList.remove('is-active'); } body.style.overflow = ''; });

const glow = document.querySelector('.premium-pointer-glow');
if (glow && !reduceMotion) {
  let frame = 0;
  window.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch') return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { glow.style.transform = `translate3d(${event.clientX}px,${event.clientY}px,0)`; glow.dataset.visible = 'true'; });
  }, { passive: true });
  document.documentElement.addEventListener('mouseleave', () => { glow.dataset.visible = 'false'; });
}

const revealTargets = document.querySelectorAll('.section-index,.work-stack__topline,.partner,.service-row,.biography__story article,.album-card,.album-price-list article,.design-case,.video-case,.loyalty-offer,.reviews-wall__header,.review-card,.reviews-form__intro,.reviews-form form');
if (reduceMotion || !('IntersectionObserver' in window)) revealTargets.forEach(item => item.classList.add('is-in-view'));
else {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-in-view'); observer.unobserve(entry.target); } }), { threshold: .08, rootMargin: '0px 0px -5%' });
  revealTargets.forEach(item => { item.classList.add('premium-reveal'); observer.observe(item); });
}

document.querySelectorAll('[data-album-deck]').forEach(deck => {
  let active = false;
  let moved = false;
  let startX = 0;
  let scrollLeft = 0;
  deck.addEventListener('pointerdown', event => { active = true; moved = false; startX = event.clientX; scrollLeft = deck.scrollLeft; deck.classList.add('is-dragging'); deck.setPointerCapture(event.pointerId); });
  deck.addEventListener('pointermove', event => { if (!active) return; const delta = event.clientX - startX; if (Math.abs(delta) > 7) moved = true; deck.scrollLeft = scrollLeft - delta; });
  const end = () => { active = false; window.setTimeout(() => deck.classList.remove('is-dragging'), 0); };
  deck.addEventListener('pointerup', end);
  deck.addEventListener('pointercancel', end);
  deck.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
});

document.querySelectorAll('[data-open-home-album]').forEach(button => {
  const modal = document.getElementById(button.getAttribute('aria-controls'));
  const closeButton = modal?.querySelector('[data-close-home-album]');
  const openAlbum = () => { if (!modal) return; modal.hidden = false; body.style.overflow = 'hidden'; closeButton?.focus(); };
  const closeAlbum = () => { if (!modal) return; modal.hidden = true; body.style.overflow = ''; button.focus(); };
  button.addEventListener('click', openAlbum);
  closeButton?.addEventListener('click', closeAlbum);
  modal?.addEventListener('click', event => { if (event.target === modal) closeAlbum(); });
  modal?.addEventListener('keydown', event => { if (event.key === 'Escape') closeAlbum(); });
});

document.querySelectorAll('[data-design-gallery]').forEach(gallery => {
  const posters = [...gallery.querySelectorAll('.design-case__poster')];
  const dots = [...gallery.querySelectorAll('[data-design-dot]')];
  const number = gallery.querySelector('[data-design-number]');
  if (!posters.length) return;
  let index = 0;
  const show = next => {
    index = (next + posters.length) % posters.length;
    posters.forEach((poster, position) => {
      poster.classList.toggle('design-case__poster--active', position === index);
      poster.classList.toggle('design-case__poster--behind', position !== index);
      poster.style.zIndex = position === index ? '2' : '1';
      poster.style.opacity = position === index || position === ((index + 1) % posters.length) ? '1' : '0';
    });
    dots.forEach((dot, position) => dot.classList.toggle('is-active', position === index));
    if (number) number.textContent = String(index + 1).padStart(2, '0');
  };
  gallery.querySelectorAll('[data-design-next]').forEach(button => button.addEventListener('click', () => show(index + 1)));
  gallery.querySelector('[data-design-prev]')?.addEventListener('click', () => show(index - 1));
  dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.designDot))));
  show(0);
});

document.querySelectorAll('[data-booking]').forEach(booking => {
  const panels = [...booking.querySelectorAll('[data-booking-panel]')];
  const stepButtons = [...booking.querySelectorAll('[data-booking-step-button]')];
  const serviceCards = [...booking.querySelectorAll('[data-service]')];
  const playersInput = booking.querySelector('[data-player-count]');
  const playerField = booking.querySelector('[data-player-field]');
  const summaryPlayers = booking.querySelector('[data-summary-players]');
  const summaryService = booking.querySelector('[data-summary-service]');
  const summaryPrice = booking.querySelector('[data-summary-price]');
  const summaryLabel = booking.querySelector('[data-summary-price-label]');
  const serviceInput = booking.querySelector('[data-service-input]');
  const priceInput = booking.querySelector('[data-price-input]');
  let step = 1;
  let service = 'match';
  const services = {
    match: { name: 'Reservar partido', description: 'Fotografío el partido completo y entrego una selección editada con acciones, celebraciones, retratos y momentos de equipo.', pricing: 'Añade los jugadores que quieras. 1–10: <strong>120€</strong> · 11–14: <strong>8€ / jugador</strong> · 15 o más: <strong>6€ / jugador</strong>.' },
    recording: { name: 'Reservar grabación', description: 'Una pieza audiovisual diseñada a medida para el formato, la localización y el objetivo del proyecto.', pricing: 'El precio se prepara <strong>a medida</strong>. Envía los detalles y recibirás un presupuesto personalizado.' },
    tournament: { name: 'Reservar torneo', description: 'Cobertura fotográfica completa de una jornada de torneo, con acción, ambiente y momentos de equipo.', pricing: 'Tarifa fija de <strong>175€ por jornada</strong>.' }
  };
  const price = () => {
    const players = Math.max(1, Number(playersInput?.value || 1));
    if (service === 'recording') return null;
    if (service === 'tournament') return 175;
    if (players >= 15) return players * 6;
    if (players >= 11) return players * 8;
    return 120;
  };
  const refresh = () => {
    const total = price();
    const players = Math.max(1, Number(playersInput?.value || 1));
    if (summaryPlayers) summaryPlayers.textContent = String(players);
    if (summaryService) summaryService.textContent = services[service].name;
    if (summaryPrice) summaryPrice.textContent = total === null ? 'A MEDIDA' : `${total}€`;
    if (summaryLabel) summaryLabel.textContent = total === null ? 'pedir presupuesto' : service === 'tournament' ? 'por jornada' : 'precio estimado';
    if (serviceInput) serviceInput.value = services[service].name;
    if (priceInput) priceInput.value = total === null ? 'Presupuesto' : `${total} €`;
    if (playerField) playerField.hidden = service !== 'match';
  };
  const setStep = next => {
    step = Math.max(1, Math.min(3, next));
    panels.forEach(panel => { panel.hidden = Number(panel.dataset.bookingPanel) !== step; });
    stepButtons.forEach(button => { const value = Number(button.dataset.bookingStepButton); button.disabled = value > step; button.classList.toggle('is-active', value === step); button.classList.toggle('is-complete', value < step); });
  };
  serviceCards.forEach(card => card.addEventListener('click', () => {
    service = card.dataset.service;
    serviceCards.forEach(item => { const selected = item === card; item.classList.toggle('is-selected', selected); item.setAttribute('aria-checked', String(selected)); item.querySelector('i').textContent = selected ? '✓' : '↗'; });
    booking.querySelector('[data-service-description]').textContent = services[service].description;
    booking.querySelector('[data-service-pricing]').innerHTML = services[service].pricing;
    refresh();
  }));
  booking.querySelectorAll('[data-booking-next]').forEach(button => button.addEventListener('click', () => setStep(step + 1)));
  booking.querySelectorAll('[data-booking-back]').forEach(button => button.addEventListener('click', () => setStep(step - 1)));
  stepButtons.forEach(button => button.addEventListener('click', () => { if (!button.disabled) setStep(Number(button.dataset.bookingStepButton)); }));
  booking.querySelector('[data-player-minus]')?.addEventListener('click', () => { playersInput.value = Math.max(1, Number(playersInput.value || 1) - 1); refresh(); });
  booking.querySelector('[data-player-plus]')?.addEventListener('click', () => { playersInput.value = Number(playersInput.value || 1) + 1; refresh(); });
  playersInput?.addEventListener('input', refresh);
  setStep(1);
  refresh();
});

document.querySelectorAll('[data-photo-store]').forEach(store => {
  const modal = store.querySelector('[data-album-modal]');
  const openButton = store.querySelector('[data-open-album]');
  const closeButton = store.querySelector('[data-close-album]');
  const inputs = [...store.querySelectorAll('.album-shop__photos input[type="checkbox"]')];
  const addButton = store.querySelector('[data-add-selected]');
  const update = () => {
    const selected = inputs.filter(input => input.checked);
    store.querySelectorAll('[data-selection-count]').forEach(item => { item.textContent = String(selected.length); });
    inputs.forEach(input => input.closest('article')?.classList.toggle('is-selected', input.checked));
    if (addButton) addButton.disabled = selected.length === 0;
  };
  const openAlbum = () => { if (!modal) return; modal.hidden = false; body.style.overflow = 'hidden'; closeButton?.focus(); };
  const closeAlbum = () => { if (!modal) return; modal.hidden = true; body.style.overflow = ''; openButton?.focus(); };
  openButton?.addEventListener('click', openAlbum);
  closeButton?.addEventListener('click', closeAlbum);
  modal?.addEventListener('click', event => { if (event.target === modal) closeAlbum(); });
  modal?.addEventListener('keydown', event => { if (event.key === 'Escape') closeAlbum(); });
  inputs.forEach(input => input.addEventListener('change', update));
  addButton?.addEventListener('click', async () => {
    const items = inputs.filter(input => input.checked).map(input => ({ id: Number(input.value), quantity: 1 }));
    if (!items.length) return;
    addButton.disabled = true;
    try {
      const response = await fetch(store.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.href = store.dataset.cartUrl;
    } catch (error) { addButton.disabled = false; showGuard('No se ha podido añadir al carrito. Inténtalo de nuevo.'); }
  });
  update();
});

if (location.hash.startsWith('#album-')) {
  window.setTimeout(() => document.querySelector(`${location.hash} [data-open-album]`)?.click(), reduceMotion ? 0 : 420);
}

document.querySelectorAll('[data-rating]').forEach(rating => {
  const buttons = [...rating.querySelectorAll('[data-rating-value]')];
  const output = rating.querySelector('[data-rating-output]');
  const input = rating.querySelector('[data-rating-input]');
  buttons.forEach(button => button.addEventListener('click', () => {
    const value = Number(button.dataset.ratingValue);
    buttons.forEach(item => item.classList.toggle('is-active', Number(item.dataset.ratingValue) <= value));
    output.textContent = `${value}.0`;
    input.value = String(value);
  }));
});

let guardTimer = 0;
const showGuard = (message = 'Este contenido está protegido.') => {
  if (!guardToast) return;
  window.clearTimeout(guardTimer);
  guardToast.querySelector('[data-guard-message]').textContent = message;
  guardToast.hidden = false;
  guardToast.classList.add('is-visible');
  guardTimer = window.setTimeout(() => { guardToast.classList.remove('is-visible'); guardToast.hidden = true; }, 2400);
};
document.addEventListener('contextmenu', event => { event.preventDefault(); showGuard('La copia y el guardado directo están desactivados.'); });
document.addEventListener('dragstart', event => { if (event.target.closest('img,video,.gfx-protected')) event.preventDefault(); });
window.addEventListener('keydown', event => {
  const key = event.key.toLowerCase();
  const capture = event.key === 'PrintScreen' || ((event.metaKey || event.ctrlKey) && event.shiftKey && ['s', '3', '4', '5'].includes(key));
  const developerTools = event.key === 'F12' || ((event.ctrlKey || event.metaKey) && event.shiftKey && ['i', 'j', 'c'].includes(key)) || ((event.ctrlKey || event.metaKey) && key === 'u');
  if (capture) { event.preventDefault(); body.classList.add('capture-guard'); showGuard('Las capturas están desactivadas en la galería.'); window.setTimeout(() => body.classList.remove('capture-guard'), 1500); }
  else if (developerTools || ((event.ctrlKey || event.metaKey) && ['s', 'p'].includes(key))) { event.preventDefault(); showGuard('Esta acción está desactivada.'); }
});
document.addEventListener('visibilitychange', () => {
  if (document.hidden) body.classList.add('capture-guard');
  else window.setTimeout(() => body.classList.remove('capture-guard'), 350);
});
